import React, { Suspense } from 'react';
import { Box, Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { Profile as ProfileView } from '@modules/Users/views/Profile';

export const Profile = () => {

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading />}>
        <Container maxWidth="sm">
          <Box py={3}>
            <ProfileView />
          </Box>
        </Container>
      </Suspense>
    </ErrorBoundary>
  );
};
